export default "__VITE_ASSET__2d61f150__"